import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { ModalService } from 'src/app/services/modal.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { updateApplicationStatus, updatePreEnlistmentStatus } from 'src/app/store/actions/student.action';

@Component({
  selector: 'app-update-preenlistment-status',
  templateUrl: './update-preenlistment-status.component.html',
  styleUrls: ['./update-preenlistment-status.component.scss']
})
export class UpdatePreenlistmentStatusComponent implements OnInit {

  preEnlistment!: any
  schoolYearId!: any
  application: any

  form: FormGroup

  interviewDateRequired = false;
  interviewTimeRequired = false;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    console.log(this.preEnlistment);
    this.form = this.fb.group({
      status: ['', [Validators.required]],
    });

    this.form.patchValue({
      status: this.preEnlistment?.preenlistment_status
    });

    console.log(this.schoolYearId);
  }

  update(){
    const payload = {
      preenlistment_status: this.status?.value,
    }

    console.log(payload);
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(updatePreEnlistmentStatus({preEnlistmentId: this.preEnlistment?.id, data: payload, schoolYearId: this.schoolYearId?.id}));
  }

  cancel(){
    this.modalService.hideUpdatePreEnlistmentStatus();
  }

  get status(){
    return this.form.get('status');
  }
}
